const SET_CREDIT_BALANCE = 'SET_CREDIT_BALANCE'
const FEATUREFLAG_PREPAID_TOPUP_BANK_TRANSFER_ONLY =
  'FEATUREFLAG_PREPAID_TOPUP_BANK_TRANSFER_ONLY'

export { SET_CREDIT_BALANCE, FEATUREFLAG_PREPAID_TOPUP_BANK_TRANSFER_ONLY }
